module.exports = __webpack_public_path__ + "assets/img/e71693f4204e93934386c6c7827ae137.svg";